import { motion } from "framer-motion";
import { Facebook, Instagram } from "lucide-react";
import { useSiteContent } from "./siteContent";

const TikTokIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.76a4.85 4.85 0 0 1-1.01-.07z" />
  </svg>
);

export default function Footer({ onInicio }) {
  const site = useSiteContent();
  const socials = [
    {
      name: "Facebook",
      icon: <Facebook size={18} />,
      testid: "social-facebook-link",
      href: site.social_facebook,
    },
    {
      name: "Instagram",
      icon: <Instagram size={18} />,
      testid: "social-instagram-link",
      href: site.social_instagram,
    },
    {
      name: "TikTok",
      icon: <TikTokIcon size={18} />,
      testid: "social-tiktok-link",
      href: site.social_tiktok,
    },
  ];
  return (
    <footer
      data-testid="footer"
      className="bg-[#102C1F] text-[#F4F1EB]"
    >
      <div className="mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-32">
        <motion.button
          onClick={onInicio}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="block text-left font-display text-4xl italic leading-none tracking-tight sm:text-5xl lg:text-7xl"
        >
          J'aime
          <br />
          la vie
        </motion.button>

        <div className="mt-16 flex flex-col justify-between gap-10 border-t border-[#F4F1EB]/15 pt-10 md:flex-row md:items-center">
          <div className="flex gap-4">
            {socials.map((s) => (
              <a
                key={s.name}
                data-testid={s.testid}
                href={s.href}
                target={s.href !== "#" ? "_blank" : undefined}
                rel="noopener noreferrer"
                aria-label={s.name}
                className="flex items-center gap-2 rounded-full border border-[#F4F1EB]/25 px-5 py-2.5 text-xs uppercase tracking-[0.2em] transition-colors duration-300 hover:bg-[#F4F1EB] hover:text-[#102C1F]"
              >
                {s.icon}
                <span className="hidden sm:inline">{s.name}</span>
              </a>
            ))}
          </div>
          <div className="flex items-center gap-6 text-xs uppercase tracking-[0.2em] text-[#F4F1EB]/50">
            <a
              data-testid="footer-admin-link"
              href="/admin"
              className="transition-colors duration-300 hover:text-[#F4F1EB]"
            >
              Gestion
            </a>
            <p>{site.footer_text}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
